module.exports = __webpack_public_path__ + "static/media/id&verification.21597a82.png";